module.exports = __webpack_public_path__ + "static/media/partitions_material_10y_y.20e43eba.csv";